// Tiny syntax highlighter for the decorative code screens, loose enough to cover
// the Python, PHP, JS and TS snippets. Each rule names a token kind, its pattern
// and its Vuetify color classes; at any position the first matching rule wins,
// so put more specific rules first. Patterns must not use capture groups.
const RULES = [
    // Comments and Python docstrings.
    ['comment', /"""[\s\S]*?"""|\/\*[\s\S]*?\*\/|#[^\n]*|\/\/[^\n]*/, 'grey--text font-italic'],
    ['string', /"[^"\n]*"|'[^'\n]*'/, 'orange--text text--darken-3'],
    // Python decorators.
    ['decorator', /@[\w.]+/, 'amber--text'],
    [
        'declaration',
        /\b(?:class|def|function|new|extends|public|private|protected|final|static|void|any|type|const|let|var|import|export|use)\b/,
        'cyan--text font-weight-black',
    ],
    [
        'keyword',
        /\b(?:return|yield|from|if|else|elif|for|while|in|of|is|not|and|or|with|as|await|async|self|this)\b/,
        'blue--text font-weight-black',
    ],
    ['literal', /\b(?:true|false|null|undefined|None|True|False)\b|\b\d+(?:\.\d+)?\b/, 'red--text font-weight-bold'],
    // Class names and constants.
    ['type', /\b[A-Z]\w*/, 'cyan--text'],
    // Function calls, including generic ones: name<T>(...).
    ['call', /\b\w+(?=[(<])/, 'blue--text'],
    ['operator', /->|=>|::|:=|\.\.\.|[-+*/%<>=!?&|.,;:$]/, 'orange--text text--darken-3 font-weight-bold'],
    ['bracket', /[[\](){}]/, 'yellow--text'],
];

const TOKEN = new RegExp(RULES.map(([, pattern]) => `(${pattern.source})`).join('|'), 'g');
const CLASSES = Object.fromEntries(RULES.map(([kind, , classes]) => [kind, classes]));

const escapeHtml = (text) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** Splits `code` into [text, kind] pairs, `kind` being null for the text between tokens. */
export function tokenize(code) {
    const tokens = [];
    let last = 0;
    for (const match of code.matchAll(TOKEN)) {
        if (match.index > last) tokens.push([code.slice(last, match.index), null]);
        tokens.push([match[0], RULES[match.slice(1).findIndex((group) => group !== undefined)][0]]);
        last = match.index + match[0].length;
    }
    if (last < code.length) tokens.push([code.slice(last), null]);
    return tokens;
}

/** Returns `code` as HTML, with each token wrapped in a colored span. */
export function highlight(code) {
    return tokenize(code)
        .map(([text, kind]) => (kind ? `<span class="${CLASSES[kind]}">${escapeHtml(text)}</span>` : escapeHtml(text)))
        .join('');
}
